// import Swiper from "swiper"
import { q, qq } from "../../helper/q"
import { Swiper } from "swiper/dist/js/swiper.esm.js"

export const sliderInit = () => {
  const sliderElement = q(".articlesLinksSlider")
  if (sliderElement) {
    let options = {
      slidesPerView: "auto",
      spaceBetween: 16
    }
    const articlesLinksSlider = new Swiper(sliderElement, options)
  }
}
